import { endpointConstants } from "../constants";
import { get, post, put, del } from "../../utils/api-proxy";
import Cookies from "js-cookie";

export const userService = {
  login,
  logout,
  updateToken,
  switchSite,
  getAll,
  getUsersDetails,
  updateUser,
  deleteUser,
  addUser,
  getPaginated,
  getById,
  getNUsers,
  searchAddableUsers,
  changePassword,
  resetPassword,
  getByEmail,
  register,
  activate,
};

/**
 * Attempts to login
 * @param {string} username
 * @param {string} password
 */
function login(username, password, site) {
  return post(endpointConstants.AUTH, { username, password });
}

/**
 * Updates the token
 */
function updateToken() {
  return get(endpointConstants.UPDATETOKEN);
}

/**
 * logs out of the application
 */
function logout() {
  sessionStorage.removeItem("token");
}

/**
 * Switches to a site
 * @param {string} id
 */
function switchSite(id) {
  const endpoint = endpointConstants.SWITCHSITE.replace(":id", id);

  return post(endpoint, {});
}

/**
 * Get a user by id
 * @param {string} id
 */
function getById(id) {
  return get(endpointConstants.USERS.GETBYID.replace(":id", id));
}

/**
 * Get the details of all the request users
 * @param {array} ids
 */
function getUsersDetails(ids) {
  return post(endpointConstants.USERS.DETAILS, { ids });
}

/**
 * Get users paginated
 * @param {string} order
 * @param {integer} offset
 * @param {integer} limit
 * @param {string} sort
 * @param {string} searchedString
 */
function getPaginated(order, offset, limit, sort, searchedString) {
  return post(
    endpointConstants.USERS.PAGINATED.replace(
      ":searchedString",
      searchedString,
    ),
    { order, offset, limit, sort },
  );
}

/**
 * Get all the details of all users
 */
function getAll() {
  return get(endpointConstants.USERS.LIST);
}

/**
 * updates a user
 * @param {string} id
 * @param {object} user
 */
function updateUser(id, user) {
  const endpoint = endpointConstants.USERS.UPDATE.replace(":id", id);

  return put(endpoint, user);
}

/**
 * updates addable users
 * @param {integer} indexOfFirst
 * @param {integer} numerosity
 * @param {string}  boardId
 * @param {array}  ids
 */
function getNUsers(indexOfFirst, numerosity, boardId, objectType, IdsExclude) {
  const endpoint = endpointConstants.USERS.GETNUSERS.replace(
    ":indexOfFirst",
    indexOfFirst,
  )
    .replace(":numerosity", numerosity)
    .replace(":boardId", boardId)
    .replace(":objectType", objectType);

  return post(endpoint, IdsExclude);
}

/**
 * updates addable users by searching the name
 * @param {string}  string
 * @param {array}  boardId
 */
function searchAddableUsers(string, boardId) {
  const endpoint = endpointConstants.USERS.GETBYSTRING.replace(
    ":string",
    string,
  ).replace(":boardId", boardId);

  return get(endpoint);
}

/**
 * delete a user
 * @param {string} id
 */
function deleteUser(id) {
  const endpoint = endpointConstants.USERS.DELETE.replace(":id", id);

  return del(endpoint);
}

/**
 * add a new user
 * @param {object} user
 */
function addUser(user) {
  const endpoint = endpointConstants.USERS.ADD;
  var addedUser = user;
  return post(endpoint, addedUser);
}

/**
 * add a new user
 * @param {string} userId
 * @param {object} password
 */
function changePassword(userId, newPassword) {
  const endpoint = endpointConstants.USERS.CHANGEPASSWORD.replace(
    ":id",
    userId,
  );
  return put(endpoint, newPassword);
}

/**
 * reset the password of user by email
 * @param {object} emailObj
 */
function resetPassword(emailObj) {
  const endpoint = endpointConstants.USERS.RESETPASSWORD;
  return post(endpoint, emailObj);
}

/**
 * find a user by email
 * @param {object} email
 */
function getByEmail(email) {
  const endpoint = endpointConstants.USERS.GETBYEMAIL.replace(":email", email);
  return get(endpoint);
}

/**
 * register a new user for a free license
 * @param {object} registrationObj
 */
function register(registrationObj) {
  const endpoint = endpointConstants.USERS.REGISTER;
  return post(endpoint, registrationObj);
}

/**
 * register a new user for a free license
 * @param {object} activationUserObj
 */
function activate(activationUserObj, userSecret) {
  const endpoint = endpointConstants.USERS.ACTIVATE.replace(
    ":userSecret",
    userSecret,
  );
  return post(endpoint, activationUserObj);
}
